/*---------------------------------------------------------------
    TRANSLATION EVENT TYPE
  ---------------------------------------------------------------*/
export enum TranslationEventType {
  ADD = "ADD",
  EDIT = "EDIT",
  REMOVE = "REMOVE",
}

/*---------------------------------------------------------------
    TRANSLATIONS 
  ---------------------------------------------------------------*/

export interface Translation {
  id: string | null;
  translationLanguageId: string | null;
  key: string;
  value: string;
}

/*---------------------------------------------------------------
    TRANSLATIONS -> SEARCH
  ---------------------------------------------------------------*/

export interface TranslationSearchFormValues {
  search: string | null;
  languageId: string | null;
}

export interface TranslationRow {
  id: string | null;
  key: string | null;
  value: string | null;
  created: Date | null;
}

/*---------------------------------------------------------------
  CREATE
---------------------------------------------------------------*/
export interface TranslationCreateFormValues {
  translationLanguageId: string | null;
  key: string | null;
  value: string | null;
}

/*---------------------------------------------------------------
    TRANSLATIONS -> EDIT
  ---------------------------------------------------------------*/
export interface TranslationEditFormValues {
  id?: string | null;
  translationLanguageId: string | null;
  key: string | null;
  value: string | null;
}

